import { LangkahMenungguPredikatKinerjaCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PenetapanPredikatKinerja/LangkahMenungguPredikatKinerjaCard'
import { LangkahPenetapanPredikatKinerjaCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PenetapanPredikatKinerja/LangkahPenetapanPredikatKinerjaCard'

import type { LangkahObservasi } from 'app/KinerjaPage/pages/PelaksanaanV2/constants/tahapanPelaksanaan'

export const tahapanPenetapanPredikatKinerja: LangkahObservasi[] = [
  {
    imageSrc: '/illustrations/img-time-document.png',
    callToAction: 'Menunggu Predikat Kinerja Organisasi',
    description:
      'Predikat sedang diproses oleh Kemendikdasmen dan Dinas Pendidikan.',
    url: '',
    progressPercentageState: null,
    CardComponent: LangkahMenungguPredikatKinerjaCard,
  },
  {
    imageSrc: '/illustrations/img-contribution-files-folder-perangkat-ajar.png',
    callToAction: 'Lakukan Penetapan Predikat Kinerja',
    description:
      'Tetapkan berdasarkan Predikat Kinerja Organisasi. Setelah itu, kirim ke guru.',
    CtaButtonProps: {
      unlocked: {
        children: (
          <>
            Mulai
            <span className="sr-only">Lakukan Penetapan Predikat Kinerja</span>
          </>
        ),
        color: 'blue',
      },
      locked: {
        children: (
          <>
            Mulai
            <span className="sr-only">Lakukan Penetapan Predikat Kinerja</span>
          </>
        ),
        color: 'blue',
        disabled: true,
      },
      draft: {
        children: (
          <>
            Lanjutkan
            <span className="sr-only">Lakukan Penetapan Predikat Kinerja</span>
          </>
        ),
        color: 'blue',
      },
      done: {
        children: (
          <>
            Cek Riwayat Pengiriman
            <span className="sr-only">Penetapan Predikat Kinerja</span>
          </>
        ),
        color: 'white',
      },
    },
    url: '',
    progressPercentageState: null,
    CardComponent: LangkahPenetapanPredikatKinerjaCard,
  },
]
